module.exports = __webpack_public_path__ + "static/img/企业logo8.fe955f07.jpeg";